"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/web.timers.js");

var _isBoolean = _interopRequireDefault(require("lodash/isBoolean"));

var _store = _interopRequireDefault(require("@/store"));

/* eslint-disable no-caller */

/**
 * 定时刷新功能
 */
var _default = {
  clearRefreshTimer: function clearRefreshTimer() {
    if (this.refreshTimerId) {
      window.clearTimeout(this.refreshTimerId);
      this.refreshTimerId = null;

      _store["default"].dispatch('SetRefreshTimerId', this.refreshTimerId);
    }
  },
  setRefreshTimer: function setRefreshTimer() {
    var _this = this;

    var refreshInterval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : process.env.REFRESH_INTERVAL;

    // const caller = arguments.callee.caller;
    // if (!isBoolean(refreshInterval) || !isNumber(refreshInterval)) {
    //   throw new Error('refreshInterval must is number or boolean');
    // }
    if (!this.$el.__vue__) {
      console.log('vue object is destroyed stop refreshTimer');
      return;
    }

    if ((0, _isBoolean["default"])(refreshInterval)) {
      if (refreshInterval) {
        refreshInterval = process.env.REFRESH_INTERVAL;
      } else {
        return;
      }
    }

    this.clearRefreshTimer();
    this.refreshTimerId = window.setTimeout(function () {
      _this._refreshInterval(refreshInterval);
    }, refreshInterval);

    _store["default"].dispatch('SetRefreshTimerId', this.refreshTimerId);
  },
  // 刷新页面
  _refreshInterval: function _refreshInterval(refreshInterval) {
    if (this.refreshTimerId !== null) {
      this.clearRefreshTimer();
      this.setRefreshTimer(refreshInterval);
    }

    if (!this.refresh) {
      throw new Error('refresh function is undefined');
    }

    this.refresh();
  }
};
exports["default"] = _default;